"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WanikaniLevelProgression = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _kyouElements = require("kyou-elements");

var _recharts = require("recharts");

var _useWanikaniProgression = require("../useWanikaniProgression");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

const Container = _styledComponents.default.div(_templateObject());

const WanikaniLevelProgression = () => {
  const {
    isLoading,
    levelProgression
  } = (0, _useWanikaniProgression.useWanikaniProgression)();
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_kyouElements.Render, {
    when: !isLoading
  }, () => {
    return /*#__PURE__*/_react.default.createElement(_recharts.ResponsiveContainer, {
      width: "100%",
      height: "100%"
    }, /*#__PURE__*/_react.default.createElement(_recharts.BarChart, {
      data: levelProgression
    }, /*#__PURE__*/_react.default.createElement(_recharts.Bar, {
      dataKey: "daysToComplete",
      fill: _kyouElements.colors.WANI_BLUE
    }, /*#__PURE__*/_react.default.createElement(_recharts.LabelList, {
      dataKey: "daysToComplete",
      position: "top",
      fill: _kyouElements.colors.WHITE,
      fontSize: 14
    })), /*#__PURE__*/_react.default.createElement(_recharts.XAxis, {
      dataKey: "level"
    })));
  }));
};

exports.WanikaniLevelProgression = WanikaniLevelProgression;